<template>
  <b-modal :id="`use-finished${id}`" modal-class="modal-style" ref="modal">
    <template>
      <p class="modal-style-title alert-title">方案已使用完畢</p>
      <div class="modal-style-content">
        <p>很抱歉，方案已使用完畢</p>
        <p>歡迎洽櫃台購買新方案</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確認
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`use-finished${this.id}`);
    }
  }
};
</script>
